import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VSwitch,{attrs:{"disabled":_vm.loading || _vm.disabled,"loading":_vm.loading,"color":_vm.type == 'active' ? '#26BE00' : '#ed143d'},on:{"mousedown":function($event){return _vm.confirmSwith(_vm.item, _vm.value, $event)}},model:{value:(
      _vm.item[_vm.value == 'toggle-active-user' ? 'is_admin_active_user' : _vm.value]
    ),callback:function ($$v) {_vm.$set(_vm.item, _vm.value == 'toggle-active-user' ? 'is_admin_active_user' : _vm.value, $$v)},expression:"\n      item[value == 'toggle-active-user' ? 'is_admin_active_user' : value]\n    "}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }